import i18n from 'i18next';

import { ResidenceTypeEnum } from '../enums/ResidenceTypeEnum';
import { HousingTypeOption } from '../types/HousingTypeOption';

export const housingTypeOptions: HousingTypeOption[] = [
  {
    name: i18n.t('residenceType.own'),
    value: ResidenceTypeEnum.OWN,
  },
  {
    name: i18n.t('residenceType.rent'),
    value: ResidenceTypeEnum.RENT,
  },
  {
    name: i18n.t('residenceType.other'),
    value: ResidenceTypeEnum.OTHER,
  },
];
